<ll-titulo>{{ "ayudas.ayuda.titulo" | t }}</ll-titulo>

<ayuda [id]="id"></ayuda>
